import {defineStore} from "pinia";
import LaravelPiniaPlugin from "@/utils/LaravelPiniaPlugin.js";
import {isDesktop} from "@/plugins/ScreenHelper.js";


let options = {
  ...LaravelPiniaPlugin()
}

export const useClickLog = defineStore('click-log', {
  state: () => ({
    ...options.state,
    ...{
      url: '/api/v1/click',
      primaryKey: 'id',
      query: {}
    }
  }),
  getters: {
    ...options.getters,
  },
  actions: {
    ...options.actions,
    async logging(id, name=null) {
      this.url = '/api/v1/click-log';
      await this.store({
        'click_id': id,
        'click_type': 'App\\CustomEvent',
        'click_name': name ?? '',
        'platform': isDesktop() ? 'pc' : 'mobile'
      })
      this.url = '/api/v1/click';
    }
  }
});
